import styled from 'styled-components/macro';

export const TagContainer = styled.div`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.primary};
`;

export const TagLabel = styled.h6`
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
  line-height: ${({ theme }) => theme.lineHeight.one};
`;

export const IconWrapper = styled.div`
  display: flex;
  cursor: pointer;
`;
